module.exports = __webpack_public_path__ + "assets/images/flag-es-28854463adf679b44c007ff2c0468c74.png";